import Tag, { Props as TagProps } from '../../Atoms/Tag';
import Img, { Props as ImgProps } from '../../Atoms/Image';
import Icon from '../../Atoms/Icon';

export interface Props {
  title: string;
  img: ImgProps;
  tags?: TagProps[];
  onClick?: () => void;
}

function CardBlog({ title, img, tags, onClick }: Props) {
  return (
    <div
      className="group flex w-full cursor-pointer items-stretch overflow-hidden rounded-xl border only:max-w-[600px]"
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(event) => {
        if (event.key === 'Enter') {
          onClick?.();
        }
      }}
    >
      <div className="relative hidden h-auto min-h-[150px] shrink-0 basis-[150px] overflow-hidden xsm:block md:min-h-[200px] md:basis-[200px]">
        <Img
          {...img}
          className="h-full w-full object-cover object-center"
        />
      </div>
      <div className="relative flex w-full flex-col justify-between gap-7 overflow-hidden rounded-xl bg-gradient-to-l from-sl-blue via-white to-white bg-[length:200%] bg-left p-7 text-sl-blue duration-300 group-hover:via-sl-blue-dark group-hover:bg-right group-hover:text-white xsm:rounded-l-none">
        <span className="text-lg font-bold md:text-xl lg:text-2xl">
          {title}
        </span>

        {tags && (
          <div className="flex flex-wrap gap-y-1 gap-x-3 pr-5 text-sl-gray group-hover:text-white md:pr-14">
            {tags?.map((tag) => (
              <Tag key={tags.indexOf(tag)} {...tag} />
            ))}
          </div>
        )}

        <div className="absolute right-0 bottom-0 flex h-[48px] w-[48px] items-center justify-center rounded-tl-[100%] bg-gradient-to-l from-sl-blue to-sl-blue-dark pt-2 pl-2 text-center text-base text-white duration-300 group-hover:from-transparent group-hover:to-transparent md:h-[90px] md:w-[90px] md:pl-4 md:pt-4 md:text-lg">
          <Icon icon="arrow-right" />
        </div>
      </div>
    </div>
  );
}

export default CardBlog;
